(function () {
  var filtersRoot = document.querySelector('[data-followswiss-filters]');
  var productList = document.querySelector('[data-followswiss-product-list]');

  if (!filtersRoot || !productList) return;

  var buttons = filtersRoot.querySelectorAll('[data-followswiss-filter]');
  var products = productList.querySelectorAll('[data-followswiss-product-type]');

  buttons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      buttons.forEach(function (b) {
        b.classList.remove('is-active');
      });
      btn.classList.add('is-active');

      var type = btn.getAttribute('data-followswiss-filter');

      products.forEach(function (product) {
        if (type === 'all' || product.getAttribute('data-followswiss-product-type') === type) {
          product.classList.remove('is-hidden');
        } else {
          product.classList.add('is-hidden');
        }
      });
    });
  });

  var track = filtersRoot.querySelector('.followswiss-service__filters-track');

  if (track) {
    var isDown = false;
    var startX = 0;
    var scrollLeft = 0;

    track.addEventListener('mousedown', function (event) {
      isDown = true;
      track.classList.add('is-dragging');
      startX = event.pageX - track.offsetLeft;
      scrollLeft = track.scrollLeft;
    });

    ['mouseleave', 'mouseup'].forEach(function (evtName) {
      track.addEventListener(evtName, function () {
        isDown = false;
        track.classList.remove('is-dragging');
      });
    });

    track.addEventListener('mousemove', function (event) {
      if (!isDown) return;
      event.preventDefault();
      var x = event.pageX - track.offsetLeft;
      var walk = (x - startX) * 1.2;
      track.scrollLeft = scrollLeft - walk;
    });
  }
})();